/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientBrandTagResponse {
    tagId?: string;
    name?: string;
    brandKind?: ClientBrandTagResponse.BrandKindEnum;
    colorCode?: string;
}
export namespace ClientBrandTagResponse {
    export type BrandKindEnum = 'COMPANY' | 'COMPETITOR';
    export const BrandKindEnum = {
        COMPANY: 'COMPANY' as BrandKindEnum,
        COMPETITOR: 'COMPETITOR' as BrandKindEnum
    };
}
